import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { OmsServiceService } from '../../services/oms-service.service';
import { ConstantsService } from '../../services/constants.service';
import { SharedService } from '../../../../../tools/src/lib/shared/shared.service';
import { combineLatest } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from "ngx-spinner";
import { environment } from '../../../environments/environment';
import { ToastrService } from 'ngx-toastr';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-samples-collected',
  templateUrl: './samples-collected.component.html',
  styleUrls: ['./samples-collected.component.scss']
})
export class SamplesCollectedComponent implements OnInit {

  @Input() isSendStatus;
  @Input() odid;
  @Input() barcode;
  @Input() order_id;

  isbarcode=new FormControl('')

  RadioOptions0: string = "0";
  RadioOptions1: string = "0";
  RadioOptions2: string = "0";
  RadioOptions3: string = "0";
  RadioOptions4: string = "0";
  RadioOptions5: string = "0";
  RadioOptions6: string = "0";
  RadioOptions7: string = "0";
  RadioOptions8: string = "0";
  RadioOptions9: string = "0";
  RadioOptions10: string = "0";
  RadioOptions11: string = "0";
  RadioOptions12: string = "0";
  RadioOptions13: string = "0";
  RadioOptions: string = "";
  

  constructor(
    public modal: NgbActiveModal,
    private omsServiceService: OmsServiceService,
    private constantsService: ConstantsService,
    private sharedService: SharedService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private SpinnerService: NgxSpinnerService,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
  }

  modelClose()
  {
    this.modal.close();
  }

  choose_sampleoptiontype(key,e){
    let type:string = e.target.value;
    // console.log(`choose_sampleoptiontype`,key,type)
    if(key == 'RadioOptions0'){
      this.RadioOptions0 = type;
    }else if(key == 'RadioOptions1'){
      this.RadioOptions1 = type;
    }else if(key == 'RadioOptions2'){
      this.RadioOptions2 = type;
    }else if(key == 'RadioOptions3'){
      this.RadioOptions3 = type;
    }else if(key == 'RadioOptions4'){
      this.RadioOptions4 = type;
    }else if(key == 'RadioOptions5'){
      this.RadioOptions5 = type;
    }else if(key == 'RadioOptions6'){
      this.RadioOptions6 = type;
    }else if(key == 'RadioOptions7'){
      this.RadioOptions7 = type;
    }else if(key == 'RadioOptions8'){
      this.RadioOptions8 = type;
    }else if(key == 'RadioOptions9'){
      this.RadioOptions9 = type;
    }else if(key == 'RadioOptions10'){
      this.RadioOptions10 = type;
    }else if(key == 'RadioOptions11'){
      this.RadioOptions11 = type;
    }else if(key == 'RadioOptions12'){
      this.RadioOptions12 = type;
    }else if(key == 'RadioOptions13'){
      this.RadioOptions13 = type;
    }
  }

  samplecollectionSubmission(){
          if (this.isbarcode.value != "" && this.isbarcode.value != null && this.isbarcode.value != undefined) {
            let collectionRequest = {};
            collectionRequest["order_id"] = this.order_id;
            collectionRequest["option"] = 3;
            collectionRequest["barcode"] = this.isbarcode.value;
            collectionRequest["status"] = 102;
            collectionRequest["source"] = 'PHELP';
            collectionRequest["comment"] = '';
            collectionRequest["actionById"] = window.localStorage.getItem('actionById');
            collectionRequest["actionByName"] = window.localStorage.getItem('actionByName');
            collectionRequest["latitude"] = '21.34539';
            collectionRequest["longitude"] = '78.456456';
            collectionRequest["pickUpBoyName"] = '';
            collectionRequest["pickUpBoyNo"] = '';
            collectionRequest["pickUpBoyType"] = '';
            collectionRequest["isInternalCall"] = 1;
            collectionRequest["sampleType"] = [this.RadioOptions0,this.RadioOptions1,this.RadioOptions2,this.RadioOptions3,this.RadioOptions4,this.RadioOptions5,this.RadioOptions6,this.RadioOptions7,this.RadioOptions8,this.RadioOptions9,this.RadioOptions10,this.RadioOptions11,this.RadioOptions12,this.RadioOptions13];
            collectionRequest["type"] = "post";
            collectionRequest["action"] = "OMS/api/operation.php/v1/order/change/status";

            console.log(`collectionRequest`,collectionRequest)
            this.omsServiceService.orderConfirmation(collectionRequest).subscribe(
            (res) => {
              
                if (res["status"] == 1) {
                  this.toastr.success(res["message"]);
                    setTimeout(function(){                          
                      window.location.reload();
                    }, 2000);
                }else{
                  this.toastr.error(res["message"]);
                    setTimeout(function(){                          
                      window.location.reload();
                    }, 2000);
                }
              console.log(`sampleCollection`,res)
            })
      }else{
        this.toastr.error("please enter Barcode");
      }

  }

}
